import Cropper from 'react-easy-crop';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { styled, css } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import Fade from '@mui/material/Fade';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Slider } from '@mui/material';
import { getCroppedImg } from './cropperUilt';
import { useTranslation } from 'react-i18next';
import useDarkMode from '../../../hooks/useDarkMode';

export const CommonCropperModal = ({
	img,
	imgFile,
	isOpen,
	setOpen,
	onCloseModal,
	onComplete,
	aspectRatio,
	modalWidth,
	modalHeight,
	imageCropSize,
	cropShape,
	objectFit,
	setImg,
}) => {
	const { t } = useTranslation();
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [rotation, setRotation] = useState(0);
	const [zoom, setZoom] = useState(1);
	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

	const matches = useMediaQuery('(min-width:600px)');
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme');
		if (storedTheme !== null) {
			setDarkModeStatus(storedTheme === 'dark');
		}
	}, [setDarkModeStatus]);

	const onCropComplete = (croppedArea, croppedAreaPixels) => {
		setCroppedAreaPixels(croppedAreaPixels);
	};

	const showCroppedImage = async () => {
		try {
			const blobFile = await getCroppedImg(img, croppedAreaPixels, rotation, imgFile.type);
			const croppedImage = URL.createObjectURL(blobFile);
			//

			setImg(croppedImage);
			//convert blob to a file
			let file = new File([blobFile], imgFile.name, {
				type: imgFile.type ? imgFile.type : 'image/jpeg',
			});
			if (onComplete) onComplete(croppedImage, file);
		} catch (e) {
			console.error(e);
		}
		//onClose();
		setOpen(false);
		resetValues();
	};

	const resetValues = () => {
		setZoom(1);
		setRotation(0);
		setCrop({ x: 0, y: 0 });
	};

	const onClose = () => {
		if (onCloseModal) onCloseModal();
		setOpen(false);
		resetValues();
	};

	return (
		<Modal
			aria-labelledby='transition-modal-title'
			aria-describedby='transition-modal-description'
			open={isOpen}
			onClose={(_, reason) => reason === 'backdropClick' && onClose}
			closeAfterTransition
			slots={{ backdrop: StyledBackdrop }}>
			<Fade in={isOpen}>
				<ModalContent
					sx={{
						height: modalHeight ?? '450px',
						width: modalWidth ?? matches ? '550px' : '330px',
						flexDirection: 'column',
						backgroundColor: darkModeStatus ? '#242632' : '#ececec',
						color: darkModeStatus ? 'white' : null,
					}}>
					<div
						className='pb-2 modal-header'
						style={{ paddingRight: '18px', paddingTop: '15px' }}>
						<h4 style={{ color: darkModeStatus ? 'white' : '#3d4349', margin: 0 }}>
							{t('Crop Image')}
						</h4>
					</div>
					<div
						style={{
							height: '100%',
							width: '100%',
							padding: '0px 10px 10px 10px',
							overflow: 'hidden',
						}}>
						<div
							style={{
								position: 'relative',
								height: '100%',
								width: '100%',
								//padding: '10px',
								background: 'black',
								overflow: 'hidden',
								//borderRadius: '15px 15px 15px 15px',
							}}>
							<Cropper
								//style={{containerStyle:{marginRight: '10px', marginLeft:'10px'}}}
								style={{ cropAreaStyle: { color: '#000000b0' } }}
								image={img}
								crop={crop}
								rotation={rotation}
								cropSize={imageCropSize}
								zoom={zoom}
								cropShape={cropShape}
								objectFit={objectFit ?? 'horizontal-cover'}
								aspect={aspectRatio ?? 1 / 1}
								onCropChange={setCrop}
								onRotationChange={setRotation}
								onCropComplete={onCropComplete}
								onZoomChange={setZoom}
							/>
						</div>
					</div>
					<div className='px-5'>
						<div>
							<label>{t('Zoom')}</label>
							<Slider
								value={zoom}
								min={1}
								max={3}
								step={0.1}
								aria-labelledby='Zoom'
								onChange={(e, zoom) => setZoom(zoom)}
							/>
						</div>
						<div>
							<label>{t('Rotation')}</label>
							<Slider
								value={rotation}
								min={0}
								max={360}
								step={1}
								aria-labelledby='Rotation'
								onChange={(e, rotation) => setRotation(rotation)}
							/>
						</div>
					</div>

					<div
						className='row'
						style={{
							height: '20%',
							alignContent: 'center',
							// backgroundColor: '#3aba6f',
						}}>
						<div className='col text-center h-100 d-flex align-items-center justify-content-center p-0'>
							<button
								type='button'
								className='btn btn'
								onClick={() => onClose()}
								data-mdb-ripple-init
								style={{
									borderRadius: '0px',
									height: '100%',
									width: '100%',
									fontSize: '18px',
									paddingTop: '10px',
									paddingBottom: '10px',
									boxShadow: 'none',
									backgroundColor: darkModeStatus ? '#808080' : '#e6e6e6',
									color: '#3d4349',
									transition: 'background-color 0.3s ease',
								}}
								onMouseEnter={(e) => {
									if (darkModeStatus) e.target.style.backgroundColor = '#e6e6e6';
								}}
								onMouseLeave={(e) => {
									if (darkModeStatus) e.target.style.backgroundColor = '#808080';
								}}>
								{t('Cancel')}
							</button>
						</div>

						<div className='col d-flex align-items-center justify-content-center p-0'>
							<button
								type='button'
								className='btn btn'
								onClick={() => showCroppedImage()}
								data-mdb-ripple-init
								style={{
									borderRadius: '0px',
									height: '100%',
									width: '100%',
									fontSize: '18px',
									paddingTop: '10px',
									paddingBottom: '10px',
									boxShadow: 'none',
									color: darkModeStatus ? '#808080' : 'white',
									backgroundColor: darkModeStatus ? '#1f6340' : '#3aba6f',
									transition: 'background-color 0.3s ease',
								}}
								onMouseEnter={(e) => {
									if (darkModeStatus) e.target.style.backgroundColor = '#3aba6f';
									if (darkModeStatus) e.target.style.color = 'white';
								}}
								onMouseLeave={(e) => {
									if (darkModeStatus) e.target.style.backgroundColor = '#1f6340';
									if (darkModeStatus) e.target.style.color = '#808080';
								}}>
								{t('Done')}
							</button>
						</div>
					</div>
				</ModalContent>
			</Fade>
		</Modal>
	);
};

/*CommonCropperModal.propTypes = {
	img: PropTypes.any,
	isOpen: PropTypes.any.isRequired,
	setOpen: PropTypes.any.isRequired,
	imgFile: PropTypes.any,
	aspectRatio: PropTypes.number.isRequired,
	onComplete: PropTypes.func,
	onCloseModal: PropTypes.func,
	setImg: PropTypes.any.isRequired,
};*/

const Backdrop = React.forwardRef((props, ref) => {
	const { open, ...other } = props;
	return (
		<Fade in={open}>
			<div ref={ref} {...other} />
		</Fade>
	);
});

Backdrop.propTypes = {
	open: PropTypes.bool,
};

const blue = {
	200: '#99CCFF',
	300: '#66B2FF',
	400: '#3399FF',
	500: '#007FFF',
	600: '#0072E5',
	700: '#0066CC',
};

const grey = {
	50: '#F3F6F9',
	100: '#E5EAF2',
	200: '#DAE2ED',
	300: '#C7D0DD',
	400: '#B0B8C4',
	500: '#9DA8B7',
	600: '#6B7A90',
	700: '#434D5B',
	800: '#303740',
	900: '#1C2025',
};

const Modal = styled(BaseModal)`
	position: fixed;
	z-index: 1300;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
	z-index: -1;
	position: fixed;
	inset: 0;
	background-color: rgb(0 0 0 / 0.57);
	-webkit-tap-highlight-color: transparent;
`;
//rgb(181 171 171 / 0.3)
const ModalContent = styled('div')(
	({ theme }) => css`
		text-align: center;
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 8px;
		overflow: hidden;
		background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
		border-radius: 20px;
		border: 0px solid transparent;
		outline: none;
		box-shadow: 0 4px 12px
			${theme.palette.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(0 0 0 / 0.2)'};
		padding: 0px;
		color: ${theme.palette.mode === 'dark' ? grey[50] : grey[900]};

		& .modal-title {
			color: white;
			margin: 0;
			line-height: 1.5rem;
			margin-bottom: 8px;
		}

		& .modal-description {
			margin: 0;
			line-height: 1.5rem;
			font-weight: 400;
			color: ${theme.palette.mode === 'dark' ? grey[400] : grey[800]};
			margin-bottom: 4px;
		}
	`,
);
